function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st00{fill:#4D4D4D;}\n\t.st01{fill:#754C24;}\n\t.st02{fill:#F69B76;}\n\t.st03{fill:#E88D6D;}\n\t.st04{fill:#F8C09D;}\n\t.st05{fill:#333333;}\n\t.st06{fill:#F6AE8D;}\n\t.st07{fill:#EF937E;}\n\t.st08{fill:none;stroke:#EF937E;stroke-width:4.5315;stroke-linecap:round;stroke-miterlimit:10;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st00",
  d: "M895.8,650.5h-1.3c-41.6,0-75.4-34.2-75.4-75.8v-0.2h152v0.2C971.2,616.4,937.4,650.5,895.8,650.5z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "st01",
  d: "M870.8,916.5l0,41L790,958c0,0,3-18.4,22.9-21.9s36.6,7.8,36.6,7.8l2.1-27.3H870.8z"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 840.2,
  y: 574.5,
  className: "st00",
  width: 41,
  height: 342
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "st01",
  d: "M918.9,916.5l0,41l80.8,0.4c0,0-3-18.4-22.9-21.9c-19.8-3.6-36.6,7.8-36.6,7.8l-2.1-27.3H918.9z"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 908.2,
  y: 574.5,
  transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 1857.3134 1491.0775)",
  className: "st00",
  width: 41,
  height: 342
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "st02",
  d: "M859.8,367h70.6c22.5,0,40.7,18.2,40.7,40.7v166.9h-152V407.6C819.2,385.2,837.4,367,859.8,367z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "st03",
  d: "M971.2,407.6c4.5-2.6-69.8,43.2-84.9,27.6c-20.2-21-37.9-42.5-37.9-42.5c-18.5,3.9-29.2-4.7-29.2,14.9v16.6 c7,24.6,31.2,77.9,38.4,87.5c11.7,15.6,28.4,14.5,56.6-5.7c14.6-10.4,41.1-29.2,57-40.5V407.6z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "st02",
  d: "M926.1,376.4L926.1,376.4c-6.1,8.2-4.4,19.7,3.7,25.8l110,82.3c8.2,6.1,19.7,4.4,25.8-3.7l0,0 c6.1-8.2,4.4-19.7-3.7-25.8l-110-82.3C943.8,366.6,932.2,368.3,926.1,376.4z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "st04",
  d: "M1110.7,362.3L1110.7,362.3c-3.3-1.3-4.9-5-3.7-8.3l10.5-27.4c1.3-3.3,5-4.9,8.3-3.7l0,0c3.3,1.3,4.9,5,3.7,8.3 l-10.5,27.4C1117.7,362,1114,363.6,1110.7,362.3z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "st02",
  d: "M1101.6,352L1101.6,352c-9.4-4-20.2,0.4-24.2,9.8L1034.6,463c-4,9.4,0.4,20.2,9.8,24.2l0,0 c9.4,4,20.2-0.4,24.2-9.8l42.8-101.2C1115.4,366.8,1111,356,1101.6,352z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "st05",
  d: "M1089,402.2l-49.4-2.4c-2.6-0.1-4.3-2.8-3.4-5.2l31.9-82.9c0.6-1.5,2.1-2.5,3.7-2.4l49.4,2.4 c2.6,0.1,4.3,2.8,3.4,5.2l-31.9,82.9C1092.1,401.3,1090.6,402.2,1089,402.2z"
});

var _ref14 = /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.3588 -0.9334 0.9334 0.3588 375.2912 1231.6423)",
  className: "st00",
  cx: 1084.1,
  cy: 342.7,
  rx: 10.6,
  ry: 10.6
});

var _ref15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st04",
  d: "M1098,389.8l-9.7-3.7c-4.2-1.6-6.2-6.3-4.6-10.4l12.6-32.8c1.6-4.2,6.3-6.2,10.4-4.6l9.7,3.7 c4.4,1.7,6.6,6.7,4.9,11.1l-12.2,31.8C1107.4,389.3,1102.5,391.5,1098,389.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st04",
  d: "M1114.9,348.2L1114.9,348.2c-1.3,3.3-5,4.9-8.3,3.7l-18.4-7.5c-3.3-1.3-4.9-5-3.7-8.3v0c1.3-3.3,5-4.9,8.3-3.7 l18.4,7.5C1114.5,341.2,1116.2,344.9,1114.9,348.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st04",
  d: "M1104.9,358.1L1104.9,358.1c-1.3,3.3-5,4.9-8.3,3.7l-18.4-7.5c-3.3-1.3-4.9-5-3.7-8.3v0c1.3-3.3,5-4.9,8.3-3.7 l18.4,7.5C1104.6,351.1,1106.2,354.8,1104.9,358.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st04",
  d: "M1103.3,371.2L1103.3,371.2c-1.3,3.3-5,4.9-8.3,3.7l-18.4-7.5c-3.3-1.3-4.9-5-3.7-8.3v0c1.3-3.3,5-4.9,8.3-3.7 l18.4,7.5C1103,364.2,1104.6,367.9,1103.3,371.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st04",
  d: "M1103.2,384.8L1103.2,384.8c-1.3,3.3-5,4.9-8.3,3.7l-18.4-7.5c-3.3-1.3-4.9-5-3.7-8.3l0,0 c1.3-3.3,5-4.9,8.3-3.7l18.4,7.5C1102.8,377.8,1104.4,381.5,1103.2,384.8z"
}));

var _ref16 = /*#__PURE__*/React.createElement("path", {
  className: "st02",
  d: "M885.3,501.6L885.3,501.6c9.3-4.2,13.4-15.1,9.2-24.4l-38.3-84.8c-4.2-9.3-15.1-13.4-24.4-9.2l0,0 c-9.3,4.2-13.4,15.1-9.2,24.4l38.3,84.8C865.1,501.7,876,505.8,885.3,501.6z"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  className: "st02",
  d: "M862.3,494.2L862.3,494.2c5.3,8.7,16.6,11.5,25.4,6.2l117.4-71.4c8.7-5.3,11.5-16.6,6.2-25.4v0 c-5.3-8.7-16.6-11.5-25.4-6.2l-117.4,71.4C859.8,474.1,857,485.5,862.3,494.2z"
});

var _ref18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st04",
  d: "M982.8,399.3L982.8,399.3c3,1.8,7,0.9,8.8-2.2l15.2-25.1c1.8-3,0.9-7-2.2-8.8l0,0c-3-1.8-7-0.9-8.8,2.2 l-15.2,25.1C978.9,393.6,979.8,397.5,982.8,399.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st04",
  d: "M1010.9,431.4l8.8-5.4c3.8-2.3,5-7.3,2.7-11.1l-18.3-29.9c-2.3-3.8-7.3-5-11.1-2.7l-8.8,5.4 c-4.1,2.5-5.3,7.8-2.8,11.8l17.8,29C1001.5,432.6,1006.8,433.9,1010.9,431.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st04",
  d: "M986.7,393.6L986.7,393.6c1.8,3,5.8,4,8.8,2.1l50.7-30.9c3-1.8,4-5.8,2.1-8.8v0c-1.8-3-5.8-4-8.8-2.1 l-50.7,30.9C985.8,386.6,984.9,390.6,986.7,393.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st04",
  d: "M998.3,401.5L998.3,401.5c1.8,3,5.8,4,8.8,2.1l25.1-15.4c3-1.8,4-5.8,2.1-8.8l0,0c-1.8-3-5.8-4-8.8-2.1 l-25.1,15.4C997.4,394.5,996.5,398.5,998.3,401.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st04",
  d: "M1002.3,414.1L1002.3,414.1c1.8,3,5.8,4,8.8,2.1l25.1-15.4c3-1.8,4-5.8,2.1-8.8v0c-1.8-3-5.8-4-8.8-2.1 l-25.1,15.4C1001.4,407.1,1000.4,411.1,1002.3,414.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st04",
  d: "M1004.9,427.4L1004.9,427.4c1.8,3,5.8,4,8.8,2.1l25.1-15.4c3-1.8,4-5.8,2.1-8.8l0,0c-1.8-3-5.8-4-8.8-2.1 l-25.1,15.4C1004,420.5,1003.1,424.4,1004.9,427.4z"
}));

var _ref19 = /*#__PURE__*/React.createElement("path", {
  className: "st04",
  d: "M923.9,364c0,13.4-10.9,24.5-24.3,24.5h0h-0.2c-13.4,0-24.5-11.1-24.5-24.5v-21.5h49V364z"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  className: "st06",
  d: "M874.9,358.5c8.7,4.9,18,8.1,27.1,9.2c7,0.8,14.4,0.5,21.8-1c0.1-0.9,0.2-1.8,0.2-2.7v-21.5h-49V358.5z"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  className: "st04",
  d: "M902,356.7c-34.6-4.1-72.7-39.3-67.7-81.7l15.1-127.6l153,18.1l-15.1,127.6C982.3,335.6,936.6,360.8,902,356.7z "
});

var _ref22 = /*#__PURE__*/React.createElement("rect", {
  x: 822.3,
  y: 203.9,
  transform: "matrix(0.993 0.1177 -0.1177 0.993 32.1388 -97.3707)",
  className: "st05",
  width: 36.3,
  height: 39
});

var _ref23 = /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.1177 -0.993 0.993 0.1177 500.4833 1044.3318)",
  className: "st04",
  cx: 838,
  cy: 240.5,
  rx: 21.9,
  ry: 21.9
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  className: "st07",
  d: "M833.2,243c0.5-4.3,4.4-7.3,8.6-6.8c1.2,0.1,2.3,0.5,3.2,1.1c-1.1-2.4-3.4-4.2-6.2-4.6 c-4.3-0.5-8.1,2.5-8.6,6.8c-0.4,3.1,1.1,5.9,3.6,7.5C833.3,245.9,833.1,244.5,833.2,243z"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  className: "st05",
  d: "M862.5,144.9l0,0.4l-9.5-1.1c-11.6-1.4-22.1,6.7-23.5,18.3l0-0.2l-3.5,29.7l-2.9,24.4l36,4.3l1.3-11.1 c0.9-7.4,7.3-12.6,14.7-11.7l117.1,13.9c14,1.7,26.8-8.5,28.5-22.5l6-51l-135.5-16.1C877.2,120.5,864.1,130.9,862.5,144.9z"
});

var _ref26 = /*#__PURE__*/React.createElement("polygon", {
  className: "st05",
  points: "1006.5,254.1 992.5,241.5 997.3,200.5 1012.6,202.3 "
});

var _ref27 = /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.1177 -0.993 0.993 0.1177 619.0573 1214.5569)",
  className: "st04",
  cx: 993,
  cy: 258.9,
  rx: 21.9,
  ry: 21.9
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  className: "st07",
  d: "M999.9,262.8c0.5-4.3-2.5-8.1-6.8-8.6c-1.2-0.1-2.3,0-3.4,0.4c1.6-2.1,4.3-3.3,7.1-3c4.3,0.5,7.3,4.4,6.8,8.6 c-0.4,3.1-2.5,5.5-5.3,6.4C999.1,265.5,999.7,264.2,999.9,262.8z"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  className: "st08",
  d: "M891.8,284.9c-1.6,13.5,8.1,25.8,21.6,27.4h0c13.5,1.6,25.8-8.1,27.4-21.6"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  className: "st07",
  d: "M915.3,261.5l-1.9,15.7c-0.1,0.7,0.7,1.4,1.4,1.5l9.3,1.1c2.5,0.3,4.3-2.5,2.9-4.6l-9.2-14.2 C917.2,259.9,915.4,260.3,915.3,261.5z"
});

var _ref31 = /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.1177 -0.993 0.993 0.1177 537.3467 1103.369)",
  className: "st05",
  cx: 889.6,
  cy: 249.3,
  rx: 8.8,
  ry: 5
});

var _ref32 = /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.1177 -0.993 0.993 0.1177 585.5537 1172.5751)",
  className: "st05",
  cx: 952.7,
  cy: 256.8,
  rx: 8.8,
  ry: 5
});

function SvgManLookingAtPhoneCartoonVector(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1920 1080",
    style: {
      enableBackground: "new 0 0 1920 1080"
    },
    height: "200px",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManLookingAtPhoneCartoonVector);
export default __webpack_public_path__ + "static/media/Man_Looking_at_Phone_Cartoon_Vector.e186a317.svg";
export { ForwardRef as ReactComponent };